import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '@layouts/MainLayout.vue'
import Login from '@views/Login.vue'
import Home from '@views/Home.vue'
import Page404 from '@views/Page404.vue'
import store from '@store/index.js'
import MENUS from "@/menu.js"

function BuildRoutes(){
  const menuRoutes = [];

  // 查找叶子节点
  const FindLeafNode = m => {
    if(m.children){
      for (let i = 0; i < m.children.length; i++) {
        FindLeafNode(m.children[i]);
      }
    }
    else{
      const path = m.path;
      const title = m.title;
      const filePath = 
        m.path.indexOf('v/:id') > -1 ?
          m.path.replace(/v\/:id/g, 'Details') :
        m.path.indexOf(':id') > -1 ? 
          m.path.replace(/:id/g, 'Modify') : 
          m.path + '/Index';

      const comName = filePath.replace(/\//g, '');
      menuRoutes.push({ 
        path: path, 
        component: () => import(/* webpackChunkName: "[request]" */ `../views${filePath}.vue`).then(x => {
          x.default.name = comName;
          return x;
        }),
        meta: { 
          name: comName, 
          title: title
        }
      });
    }
  };

  for (let i = 1; i < MENUS.length; i++) {
    // 跳过首页
    FindLeafNode(MENUS[i]);
  }

  return menuRoutes;
}
//import HelloWorld from '@/components/HelloWorld'
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    name: 'Login',
    path:'/login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      ...BuildRoutes(),

      { path: '', component: Home, meta: { name: 'Home', title: '首页', path: '/' } }
    ]
  },
  {
    path: '*',
    component: Page404
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  //这个router包含了大部分的内容
  const userInfo = store.state.userInfo;
  if (to.name !== 'Login' && !userInfo.isAuth){
    const query = to.fullPath == '/' ? null : { returnUrl: to.fullPath };
    next({ name: 'Login', query });
  }
  else next();
})



export default router
